/**
 * Permission codes, in the `maps:<object>:<action>` form the backend
 * seeds (backend/CONTRATO-AUTH-RBAC.md). They only decide what to SHOW:
 * the backend checks the same permission on every endpoint.
 */
export const PERMISSIONS = [
  'maps:property:read',
  'maps:property:create',
  'maps:property:update',
  'maps:map:read',
  'maps:unit:read',
  'maps:price:read',
  'maps:plan:create',
  'maps:plan:read',
  'maps:plan:update',
  'maps:plan:delete',
  'maps:user:create',
  'maps:user:read',
  'maps:user:update',
  'maps:user:delete',
  'maps:role:create',
  'maps:role:read',
  'maps:role:update',
  'maps:role:delete',
  'maps:audit:read',
] as const

export type PermissionCode = (typeof PERMISSIONS)[number]

/** Pure check, usable without the session store. */
export function hasPermissionIn(permissions: readonly string[] | null | undefined, code: string): boolean {
  return !!permissions && permissions.includes(code)
}

/** Splits `maps:price:read` into object and action; null when malformed. */
export function parsePermission(code: string): { object: string; action: string } | null {
  const parts = code.split(':')
  if (parts.length !== 3 || !parts[1] || !parts[2]) return null
  return { object: parts[1], action: parts[2] }
}
